module.exports = __webpack_public_path__ + "static/media/property-managers-9.f066ecd8.svg";